var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Storage } from "../../services/localstorege.service";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import _ from "lodash";
import { useEffect, useState } from "react";
import { gameNameFixer, gameNavigationMiddleware, useForceUpdate, } from "../../services/misc.functions";
import { isMobile } from "../../App";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router";
import { auth, authSubject } from "../../store/auth.store";
export function HomeGamesVertical() {
    var _this = this;
    var _a = useState([]), gamesList = _a[0], setGamesList = _a[1];
    var _b = useState(0), gamesGroup = _b[0], setGamesGroup = _b[1];
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        getGames().then(function (res) {
            if (gamesGroup === 0) {
                setGamesList(res);
            }
            if (gamesGroup === 1) {
                setGamesList(res.filter(function (game) {
                    return game.is_active === true;
                }));
            }
            if (gamesGroup === 2) {
                setGamesList(res.filter(function (game) {
                    return game.is_active === false;
                }));
            }
        });
    }, [gamesGroup]);
    useEffect(function () {
        var auth_subscriber = authSubject.subscribe(function (res) {
            forceUpdate();
        });
        return function () {
            auth_subscriber.unsubscribe();
        };
    }, []);
    var getGames = function () { return __awaiter(_this, void 0, void 0, function () {
        var games;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    games = Storage.get("games");
                    if (games) {
                        if (gamesGroup === 1) {
                            return [2 /*return*/, games.filter(function (game) {
                                    return game.tag === "Yeni";
                                })];
                        }
                        else if (gamesGroup === 2) {
                            return [2 /*return*/, games.filter(function (game) {
                                    return game.is_active === false;
                                })];
                        }
                        else {
                            return [2 /*return*/, games];
                        }
                    }
                    return [4 /*yield*/, api.start("get", env.accounting_api + "/games/api/list-game/", null, false).then(function (res) {
                            if (res && res.status) {
                                var d = _.orderBy(res.data, ["ordering"], "asc");
                                Storage.set("games", d, 60 * 60 * 5);
                                if (gamesGroup === 1) {
                                    return d.filter(function (game) {
                                        return game.tag === "Yeni";
                                    });
                                }
                                else if (gamesGroup === 2) {
                                    return d.filter(function (game) {
                                        return game.is_active === false;
                                    });
                                }
                                else {
                                    return d;
                                }
                            }
                            else {
                                return [];
                            }
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    return (_jsx("div", __assign({ className: "games-slider-container" }, { children: _jsxs("div", __assign({ className: "home-games-slider" }, { children: [_jsx("div", { className: "clearfix" }), _jsxs("div", __assign({ className: "slider-container" }, { children: [_jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("h2", __assign({ style: { marginBlock: "-16px" }, className: "home-heading d-none d-xl-block d-lg-block ps-3" }, { children: "Oyunlar" })) })) })), _jsx("hr", { className: "d-none d-xl-block d-lg-block" }), !isMobile && (_jsxs("div", __assign({ className: "home-game-tabs" }, { children: [_jsx("h2", __assign({ className: "pointer ".concat(gamesGroup === 0 && "active", " "), onClick: function () {
                                        setGamesGroup(0);
                                    } }, { children: "\uD83C\uDFAE Dijital Oyunlar" })), _jsx("h2", __assign({ className: "pointer ".concat(gamesGroup === 1 && "active", " "), onClick: function () {
                                        setGamesGroup(1);
                                    } }, { children: "\u2B50 Yeni Oyunlar" })), _jsx("h2", __assign({ className: "pointer ".concat(gamesGroup === 2 && "active", " "), onClick: function () {
                                        setGamesGroup(2);
                                    } }, { children: "\u23F3 Gelecek Oyunlar" }))] }))), _jsxs("div", __assign({ className: "d-flex flex-column games-list-vertical-container" }, { children: [_jsx("div", __assign({ className: "row games-list-vertical" }, { children: gamesList.map(function (game, key) {
                                        var _a, _b;
                                        return (_jsx("div", __assign({ className: "col-4 col-md-3" }, { children: _jsxs("div", __assign({ className: "game-widget pointer" }, { children: [_jsx("img", { className: "img-fluid", src: env.cdn_host + "/media/" + game.image, onClick: function () {
                                                            gameNavigationMiddleware(game, navigate);
                                                        } }), !isMobile && (_jsx("div", __assign({ className: "game-widget-title" }, { children: _jsx("h3", __assign({ className: "nowrap" }, { children: gameNameFixer(game.name) })) }))), !isMobile && (_jsx("div", __assign({ className: "".concat(game.is_active === true ? "playable" : "", " ").concat(game.is_active === false &&
                                                            ((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id) &&
                                                            auth.remaining_games.includes(game.id)
                                                            ? "remanded"
                                                            : "", " body  mt-2") }, { children: _jsxs("span", __assign({ className: "label text-center", onClick: function () {
                                                                gameNavigationMiddleware(game, navigate);
                                                            } }, { children: [game.is_active === true && _jsx(_Fragment, { children: "Oyna" }), game.is_active !== true &&
                                                                    game.reminer !== true && (_jsx(_Fragment, { children: ((_b = auth.member) === null || _b === void 0 ? void 0 : _b.id) &&
                                                                        auth.remaining_games.includes(game.id)
                                                                        ? "✅ Hatırlatıcı kuruldu"
                                                                        : "⏰ Hatırlat" }))] })) })))] })) }), "game-vertical-".concat(key)));
                                    }) })), _jsxs("div", __assign({ id: "fade-bottom", style: {
                                        position: "sticky",
                                        bottom: -1,
                                        height: "75px",
                                        background: "linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,0))",
                                        pointerEvents: "none",
                                        zIndex: 10,
                                    } }, { children: [" ", _jsx("div", { style: { height: "75px" } })] }))] }))] }))] })) })));
}
